<template>
    <div class="app-main__inner">
    <div class="app-page-title">
      <div class="page-title-wrapper">
        <div class="page-title-heading">
          <div class="page-title-icon">
            <i class="icon-gradient bg-amy-crisp fas fa-clipboard-list"></i>
          </div>
          <h2 class="text-secondary">Editar Recibo</h2>
        </div>
        <div class="page-title-actions">
          <button class="btn btn-primary" @click="agregarConcepto">Agregar Concepto</button>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
        <div class="row">
          <div class="col-lg-12">
            <div class="main-card mb-3 card">
              <div class="card-body">
                <ModalSeleccionarConcepto v-if="abrirSeleccionarConcepto" @cerrarSelectConcepto="abrirSeleccionarConcepto = false" @selectConcepto="seleccionConcepto"/>
                  <h5><b class="text-success">{{recibo.nombre}}</b> - Legajo N°: <b class="text-success">{{recibo.numero_legajo}}</b></h5>
                  <p>Conceptos:</p>
                  <div class="mb-3 col-12">
                    <div class="row">
                      <ul class="list-group list-group-flush mb-3 col-12" v-if="searching">
                        <li class="list-group-item">
                            <div class="skeleton">
                            <div class="skeleton-author"></div>
                            <div class="skeleton-content"></div>
                            <div class="skeleton-content"></div>
                            </div>
                        </li>
                        <li class="list-group-item">
                            <div class="skeleton">
                            <div class="skeleton-author"></div>
                            <div class="skeleton-content"></div>
                            <div class="skeleton-content"></div>
                            </div>
                        </li>
                      </ul>
                      <ul class="list-group list-group-flush mb-3" v-else-if="recibo.conceptos.length == 0">
                        <li class="list-group-item">
                            <h5 class="text-center">No se encontraron resultados</h5>
                        </li>
                      </ul>
                      <ul class="list-group list-group-flush mb-3 col-12" v-else>
                        <li class="list-group-item hoverable" v-for="(concepto, i) in recibo.conceptos" :key="i" @click="opcionesConcepto(concepto)">
                          <div class="widget-content p-0">
                              <div class="widget-content-wrapper row">
                              <div class="widget-content-left col-12">
                                  <h5 class="widget-heading">
                                  <span class="text-primary">
                                      <span>{{concepto.codigo}} - {{concepto.concepto}}</span>
                                  </span>
                                  </h5>
                                  <div class="widget-subheading opacity-10 row">
                                  <span class="col-sm-auto col-12 row">
                                      <span class="text-left col-sm-auto col-12">
                                      Tipo:
                                      <b class="text-alternate">{{concepto.tipo}}</b>
                                      </span>
                                      <span class="ml-lg-3 text-left col-sm-auto col-12">
                                      Importe:
                                      <b class="text-alternate"> $ {{concepto.importe}}</b>
                                      </span>
                                  </span>
                                  </div>
                              </div>
                              </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
              </div>
            </div>
            <div class="col-md-12 row d-flex flex-row-reverse mb-4">
              <button class="btn btn-primary" @click="guardarRecibo">Guardar</button>
              <button class="btn btn-danger mr-2" @click="atras">Volver</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Swal from "sweetalert2";
//import Conceptos from '@/models/concepto'
import ModalSeleccionarConcepto from "@/components/views/recibo/ModalSeleccionarConcepto";
export default {
  name: "EditarRecibo",
  components: {
    ModalSeleccionarConcepto,
  },
  data() {
    return {
      recibo: {},
      abrirSeleccionarConcepto: false,
      //conceptos: new Conceptos(null, null, null, null),
      searching: true,
      conceptoSeleccionado: [],
    };
  },
  created() {
    this.recibo.id = this.recibo_id;
    this.getRecibo();
  },
  props:['recibo_id'],
  mounted() {},
  methods: {
    getRecibo() {
      this.loading = true;
      axios
        .get("recibo/" + this.recibo.id)
        .then((res) => {
          if (res.data.success) {
            console.log(res.data);
            this.recibo = res.data.recibo;
            //this.conceptos = res.data.recibo.conceptos;
            this.searching = false;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado Recibo.`,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    opcionesConcepto(concepto) {
      Swal.fire({
        title: "Elija una opción...",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        cancelButtonText: "Eliminar",
      }).then((result) => {
        if (result.value) {
          Swal.fire({
            title: "Editar importe",
            text: `¿Ingrese importe para ${concepto.concepto}?`,
            html: `<input type="text" class="form-control" id="btnImporte" value=${concepto.importe}>`,
            showCancelButton: true,
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Guardar",
          })
            .then((result) => {
              if (result.value) {
                console.log(result.value);
                concepto.importe = document.querySelector("#btnImporte").value;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          let posicion = this.recibo.conceptos.findIndex(
            (e) => e.id == concepto.id
          );
          this.recibo.conceptos.splice(posicion, 1);
        }
      });
    },
    agregarConcepto() {
      this.abrirSeleccionarConcepto = true;
    },
    seleccionConcepto(concepto) {
      this.conceptoSeleccionado = concepto;
      Swal.fire({
        title: "Agregar importe",
        text: `¿Deseas quitar ${concepto.concepto} de este recibo?`,
        html: '<input type="text" class="form-control" id="btnImporte">',
        confirmButtonColor: "#3085d6",
        confirmButtonText: "OK!",
      }).then((result) => {
        if (result.value && document.querySelector("#btnImporte").value != "") {
          this.conceptoSeleccionado.importe = document.querySelector(
            "#btnImporte"
          ).value;
          this.conceptoSeleccionado.recibo_id = this.recibo.id;
          this.conceptoSeleccionado.concepto = concepto.descripcion;
          this.conceptoSeleccionado.codigo = concepto.codigo;
          this.conceptoSeleccionado.tipo = concepto.tipo;
          this.recibo.conceptos.push(this.conceptoSeleccionado);
        }
      });
    },
    guardarRecibo() {
      axios
        .put("/recibo/" + this.recibo.id, this.recibo)
        .then((res) => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `Se editó con éxito.`,
            });
            this.$emit('guardado')
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`,
          });
        })
        .finally(() => (this.loading = false));
    },
    atras(){
      this.$emit('guardado')
    }
  },
};
</script>